export default "__VITE_ASSET__BBossbX1__"